import { useTranslation } from 'react-i18next';
import { Table } from 'rsuite';
import 'rsuite/dist/rsuite.min.css';

import { Recharges } from '@/types';
import { parseCurrency, parseDate } from '@/utils/helpers';

const { Column, HeaderCell, Cell } = Table;

export type RechargesHistoryTableProps = {
  recharges: Recharges[];
  loading: boolean;
};

export const RechargesHistoryTable = ({ recharges, loading }: RechargesHistoryTableProps) => {
  const { t, i18n } = useTranslation();
  const getNameRecharge = (data: Recharges): string => {
    return (
      `${data.name}` +
      (data.interval
        ? data.interval === 'month-12'
          ? ' (' + t('BillingMode.yearly') + ')'
          : ' (' + t('BillingMode.monthly') + ')'
        : '')
    );
  };

  return (
    <div className="mt-4 pl-12">
      <Table autoHeight={true} data={recharges} loading={loading} showHeader={true}>
        <Column align="left" width={100} resizable={true} fixed>
          <HeaderCell>{t('RechargesHistoryTable.id')}</HeaderCell>
          <Cell dataKey="id" />
        </Column>
        <Column width={350} resizable={true}>
          <HeaderCell>{t('RechargesHistoryTable.name')}</HeaderCell>
          <Cell className="capitalize">{(rowData: Recharges) => getNameRecharge(rowData)}</Cell>
        </Column>
        <Column width={150} resizable={true}>
          <HeaderCell>{t('RechargesHistoryTable.price')}</HeaderCell>
          <Cell className="capitalize">
            {(rowData: Recharges) => parseCurrency(i18n.language, rowData.currency, rowData.price)}
          </Cell>
        </Column>
        <Column flexGrow={1}>
          <HeaderCell>{t('RechargesHistoryTable.requestDate')}</HeaderCell>
          <Cell className="capitalize">
            {(rowData: Recharges) =>
              parseDate(i18n.language, rowData.paymentDate, {
                year: 'numeric',
                month: 'short',
              })
            }
          </Cell>
        </Column>
        <Column flexGrow={1}>
          <HeaderCell>{t('RechargesHistoryTable.paymentDate')}</HeaderCell>
          <Cell className="capitalize">
            {(rowData: Recharges) =>
              parseDate(i18n.language, rowData.paymentDate, {
                timeStyle: 'medium',
                dateStyle: 'medium',
              })
            }
          </Cell>
        </Column>
      </Table>
    </div>
  );
};
